module.exports = __webpack_public_path__ + "static/media/2.6f2dbf7b.jpg";